const getReconjobsPayload = (createdByBrokerId) => ({
    "eventMessage": {
        createdByBrokerId
      },
      "eventType": "RECON_SHIPMENT_LIST",
      "eventTime": Date.now()
})

const getReconFormPayload = (reconShipmentId) => ({
    "eventMessage": {
        reconShipmentId
      },
      "eventType": "RECON_SHIPMENT_GET",
      "eventTime": Date.now()
})

const createReconShipmentPayload = (importerCode, userGuid, reconciliationTypeCode, importerOfRecordNumber, importerOfRecordType, filerCode, importerEmail, processingPort, actionCode, importEntryLocationCode, comment) => ({
    "eventMessage": {
        importerCode,
        createdByBrokerId: userGuid,
        filerCode,
        importerEmail,
        importerOfRecordNumber,
        importerOfRecordType,
        reconciliationTypeCode,
        processingPort,
        actionCode,
        importEntryLocationCode,
        comment
    },
      "eventType": "RECON_SHIPMENT_ADD",
      "eventTime": Date.now()
})

const deleteReconShipmentPayload = (reconShipmenId) => ({
    "eventMessage": {
        reconShipmenId
    },
    "eventType": "RECON_SHIPMENT_DELETE",
    "eventTime": Date.now()
})

const startProcessingFilePayload = (reconShipmentId, fileName) => ({
    "eventMessage": {
        reconShipmentId,
        fileName
    },
    "eventType": "UPLOAD_RECON_DATA",
    "eventTime": Date.now()
})

const uploadStatusCheckPayload = (reconShipmentId) => ({
    "eventMessage": {
        reconShipmentId
    },
    "eventType": "UPLOAD_RECON_DATA_STATUS",
    "eventTime": Date.now()
})

const statusDetailPayload = (reconShipmentId) => ({
    "eventMessage": {
        reconShipmentId
    },
    "eventType": "RECON_JOB_STATUS_LIST",
    "eventTime": Date.now()
})

const fileReconJobPayload = (reconShipmentId) => ({
    "eventMessage": {
        reconShipmentId
    },
    "eventType": "RECON_EDI_GENERATION",
    "eventTime": Date.now()
})

const statusDetailResponsePayload = (responseId) => ({
    "eventMessage": {
        responseId
    },
    "eventType": "EDI_RESPONSE_GET",
    "eventTime": Date.now()
})

const updateFormPayload = (fields, event) => ({
    "eventMessage": {
        ...fields
    },
    "eventType": event,
    "eventTime": Date.now()
})

const addPaymentPayload = (paymentTypeCode, statementPrintDate, parentReconShipmentId) => ({
    "eventMessage": {
        paymentTypeCode,
        statementPrintDate,
        parentReconShipmentId
    },
    "eventType": "PAYMENT_ADD",
    "eventTime": Date.now()
})

export {
    getReconjobsPayload,
    getReconFormPayload,
    createReconShipmentPayload,
    deleteReconShipmentPayload,
    startProcessingFilePayload,
    statusDetailPayload,
    uploadStatusCheckPayload,
    fileReconJobPayload,
    statusDetailResponsePayload,
    updateFormPayload,
    addPaymentPayload
}